import { render, staticRenderFns } from "./RateUsComponent.vue?vue&type=template&id=32596871&scoped=true"
import script from "./RateUsComponent.vue?vue&type=script&lang=js"
export * from "./RateUsComponent.vue?vue&type=script&lang=js"
import style0 from "./RateUsComponent.vue?vue&type=style&index=0&id=32596871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32596871",
  null
  
)

export default component.exports